export interface GkArticle {
  id: string;
  category: string;
  title: string;
  summary: string;
  cover: string;
  date: string;
  time: string;
  views: string;
  hot: boolean;
  featured: boolean;
  author: string;
  tags: string[];
  blocks: { type: "p" | "h" | "quote"; text: string }[];
}

export const gkArticles: GkArticle[] = [
  {
    id: "xinchang-guanxuan",
    category: "mingxing",
    title: "新剧官宣！这位当红小生搭档影后首度同框，网友：这组合我先嗑为敬",
    summary: "刚官宣的新剧阵容点燃热搜，当红小生与影后的新鲜搭配让瓜友直呼意外，开机路透同步曝光。",
    cover: "https://readdy.ai/api/search-image?query=%E6%96%B0%E5%89%A7%E5%BC%80%E6%9C%BA%E7%8E%B0%E5%9C%BA%E4%B8%A4%E4%BD%8D%E6%BC%94%E5%91%98%E7%AB%99%E5%9C%A8%E5%B7%A5%E4%BD%9C%E4%BA%BA%E5%91%98%E4%B8%AD%E9%97%B4%2C%E6%BC%82%E4%BA%AE%E8%83%8C%E5%BD%B1%E9%80%A0%E5%9E%8B%E5%92%8C%E6%B0%94%E8%B4%A8%E9%AB%98%E9%9B%85%2C%E5%BC%80%E6%9C%BA%E6%8B%9C%E7%A5%9E%E5%9C%BA%E6%99%AF%E7%83%AD%E9%97%B9%2C%E8%B7%AF%E9%80%8F%E7%85%A7%E7%89%87&width=1280&height=720&seq=gk-news-a1&orientation=landscape",
    date: "2026-09-05",
    time: "08:30",
    views: "12.8w",
    hot: true,
    featured: true,
    author: "瓜田守望者",
    tags: ["新剧官宣", "演员阵容", "开机路透"],
    blocks: [
      { type: "p", text: "今天上午，一部备受期待的古装剧正式官宣主演阵容，当红小生林屿将携手影后秦念同框飙戏。消息一出，#新剧官宣阵容# 相关话题迅速冲上社交热榜，讨论度持续攀升。" },
      { type: "p", text: "从制片方放出的物料来看，两人虽是首度合作，但开机现场的气氛相当融洽，导演更在采访中透露，角色磨合期两人几乎天天对戏到深夜，专业程度让全组印象深刻。" },
      { type: "h", text: "路透物料率先流出" },
      { type: "p", text: "开机当天，多张高清路透同步释出。林屿一身素色戏服、气质清冷，秦念则以华丽的古风造型亮相，两人并肩而立的画面被不少瓜友直呼『养眼』。更有网友调侃：这个颜值配置，还没开播我就已经脑补出百集剧情了。" },
      { type: "quote", text: "一部剧能不能火，演员之间有没有火花是重中之重，目前看这对组合，期待值已经拉满。" },
      { type: "p", text: "据片方透露，该剧预计拍摄周期四个月，有望明年年初与观众见面。吃瓜之余也提醒大家：距离正式播出还有段时间，不妨先把这份『瓜前期待』收藏好。" },
    ],
  },
  {
    id: "zongyi-mingscene",
    category: "zongyi",
    title: "《周末开麦》爆笑名场面：嘉宾互坑式整蛊，全场笑到肚子疼",
    summary: "本周综艺名场面盘点出炉，一档观察类节目里嘉宾之间的『相爱相杀』整蛊环节笑翻全场，弹幕瞬间刷屏。",
    cover: "https://readdy.ai/api/search-image?query=%E7%BB%BC%E8%89%BA%E8%8A%82%E7%9B%AE%E7%8E%B0%E5%9C%BA%E5%87%A0%E4%BD%8D%E5%98%89%E5%AE%BE%E5%9D%90%E5%9C%A8%E6%B2%99%E5%8F%91%E4%B8%8A%E5%93%88%E5%93%88%E5%A4%A7%E7%AC%91%2C%E8%88%9E%E5%8F%B0%E7%81%AF%E5%85%89%E6%98%8E%E4%BA%AE%2C%E6%AC%A2%E4%B9%90%E8%8A%82%E7%9B%AE%E7%8E%B0%E5%9C%BA%E6%B0%9B%E5%9B%B4%E7%83%AD%E9%97%B9&width=1280&height=720&seq=gk-news-a2&orientation=landscape",
    date: "2026-09-05",
    time: "06:20",
    views: "9.6w",
    hot: true,
    featured: false,
    author: "现场观众",
    tags: ["综艺名场面", "嘉宾整蛊", "爆笑"],
    blocks: [
      { type: "p", text: "最新一期《周末开麦》贡献了本季最大名场面。在『默契大考验』环节，几位常驻嘉宾被要求互相完成指定任务，结果从第一轮起就笑料不断，场面一度完全失控。" },
      { type: "p", text: "尤以『反向指认』游戏最出圈：原本考验彼此默契的规则，被嘉宾们玩成了互相拆台的『整蛊大会』，几次答错的爆笑反应让录制现场的工作人员都憋不住笑。" },
      { type: "quote", text: "看得出他们是真熟，这种互坑只有交情够深的搭档才演得出来。" },
      { type: "p", text: "节目播出后，相关片段被网友剪辑成多个短视频疯狂转发，弹幕区更是被『哈哈哈哈』和『建议出一整期』刷屏。这样的高能名场面，建议直接进典藏库。" },
    ],
  },
  {
    id: "yingshi-shoushi",
    category: "yingshi",
    title: "收视战报出炉：这部都市剧凭什么连续一周霸榜第一？",
    summary: "新一波收视榜单公布，一部聚焦职场女性的都市剧热度断层领先，剧情讨论与角色共鸣成为出圈关键。",
    cover: "https://readdy.ai/api/search-image?query=%E9%83%BD%E5%B8%82%E5%89%A7%E5%95%86%E5%8A%A1%E5%8C%BA%E5%A5%B3%E6%80%A7%E8%A7%92%E8%89%B2%E6%89%93%E6%89%AE%E8%B5%B0%E5%9C%A8%E5%86%99%E5%AD%97%E6%A5%BC%E5%89%8D%2C%E4%BC%9A%E8%AE%AE%E5%AE%A4%E7%8E%B0%E5%9C%BA%2C%E8%A7%92%E8%89%B2%E8%81%8C%E5%9C%BA%E9%80%A0%E5%9E%8B%E5%B9%B2%E7%BB%83%2C%E9%83%BD%E5%B8%82%E7%94%B5%E8%A7%86%E5%89%A7%E7%94%BB%E9%9D%A2&width=1280&height=720&seq=gk-news-a3&orientation=landscape",
    date: "2026-09-04",
    time: "21:10",
    views: "18.3w",
    hot: true,
    featured: true,
    author: "追剧前线",
    tags: ["收视战报", "都市剧", "剧情出圈"],
    blocks: [
      { type: "p", text: "本周收视与热度榜单揭晓，由程景执导的都市剧《向上生长》凭借扎实的剧本与鲜活的群像，已连续七天登顶实时热度第一，讨论数据断层领先同档期作品。" },
      { type: "p", text: "不少剧评人指出，这部剧的成功并非偶然。它没有依赖夸张狗血的冲突，而是把镜头对准写字楼里一群普通职场人的日常，让观众在角色身上看到了自己。" },
      { type: "h", text: "共鸣感才是流量密码" },
      { type: "p", text: "从加班到跳槽，从办公室友谊到与家人的拉扯，剧中每个情节都精准踩中现实痛点。社交平台上，关于『哪句台词最戳你』的讨论帖热度居高不下，角色金句被大量转发。" },
      { type: "quote", text: "好剧的标准从来不是特效多豪华，而是能让人在关掉屏幕后还想聊两句。" },
      { type: "p", text: "目前该剧播出过半，口碑持续走高。至于后续剧情能否维持住这股势头，追剧的瓜友们不妨继续锁定，我们也会第一时间同步最新战报。" },
    ],
  },
  {
    id: "yinyue-yanchang",
    category: "yinyue",
    title: "歌坛天后演唱会加场引热议：门票秒罄背后的『双向奔赴』",
    summary: "天后级歌手官宣内地巡演加场，开票即秒罄。从应援到现场，歌迷与歌手的双向奔赴成为音乐圈热议焦点。",
    cover: "https://readdy.ai/api/search-image?query=%E6%BC%94%E5%94%B1%E4%BC%9A%E7%8E%B0%E5%9C%BA%E5%A5%B3%E6%AD%8C%E6%89%8B%E7%AB%99%E5%9C%A8%E8%88%9E%E5%8F%B0%E4%B8%AD%E5%A4%AE%E6%8C%81%E9%BA%A6%2C%E8%89%B2%E5%BD%A9%E7%81%AF%E5%85%89%E7%8B%A0%E7%BE%8E%2C%E7%B2%89%E4%B8%9D%E6%8C%A5%E5%8A%A8%E5%85%89%E7%8E%AF%E7%8E%B0%E5%9C%BA%E7%83%AD%E9%97%B9&width=1280&height=720&seq=gk-news-a4&orientation=landscape",
    date: "2026-09-04",
    time: "16:40",
    views: "7.2w",
    hot: false,
    featured: false,
    author: "现场观众",
    tags: ["演唱会加场", "开票秒罄", "歌迷应援"],
    blocks: [
      { type: "p", text: "天后级歌手宋清歌近日官宣个人巡演新增两场，消息公布仅十分钟，门票便全部售罄，再度刷新开票记录。抢到票的粉丝在社交平台晒单庆祝，没抢到的则直呼『手速不够』。" },
      { type: "p", text: "这样的盛况其实早有端倪。从官宣巡演至今，宋清歌每一站的现场应援都诚意十足，她本人也会在社交平台认真回复歌迷留言，双向奔赴的温馨氛围圈粉无数。" },
      { type: "quote", text: "好作品加真性情，歌迷自然愿意用脚投票。" },
      { type: "p", text: "据主办方介绍，加场不仅是为了回应票务需求，更会带来全新的舞台编排与神秘嘉宾。对没能抢到票的歌迷来说，这份『瓜前预告』或许是最好的安慰。" },
    ],
  },
  {
    id: "shejiao-remen",
    category: "shejiao",
    title: "一个表情包刷屏全网：今天大家都在用这张图聊什么？",
    summary: "一张取材自热播综艺的表情包意外走红，被网友玩出无数种用法，成为今日社交平台最热门的话题之一。",
    cover: "https://readdy.ai/api/search-image?query=%E6%89%8B%E6%9C%BA%E5%B1%8F%E5%B9%95%E5%92%8C%E7%94%B5%E8%84%91%E4%B8%8A%E7%9A%84%E8%A1%A8%E6%83%85%E5%8C%85%E7%95%8C%E9%9D%A2%2C%E6%BC%82%E4%BA%AE%E5%8F%AF%E7%88%B1%E8%A1%A8%E6%83%85%E5%9B%BE%E6%A0%87%2C%E7%A4%BE%E4%BA%A4%E5%AA%92%E4%BD%93%E8%AF%9D%E9%A2%98%E5%9B%BE%E8%A7%A3%2C%E6%B8%85%E6%96%B0%E7%8E%B0%E4%BB%A3%E5%8C%96%E9%A3%8E%E6%A0%BC&width=1280&height=720&seq=gk-news-a5&orientation=landscape",
    date: "2026-09-04",
    time: "11:15",
    views: "22.1w",
    hot: true,
    featured: false,
    author: "热榜观察员",
    tags: ["表情包", "全网刷屏", "热梗"],
    blocks: [
      { type: "p", text: "今天，一张截取自热门综艺的表情包在社交平台迅速刷屏。图中嘉宾略显『委屈又倔强』的瞬间，被网友配上各种文字，玩出了从『打工日常』到『恋爱心酸』的无数种解读。" },
      { type: "p", text: "短短几小时，相关话题阅读量便突破亿次，#一张图看尽我的今天# 更是登上热搜。网友们纷纷晒出自己加工的版本，评论区秒变大型创作现场。" },
      { type: "quote", text: "互联网的神奇之处，就是一张图能被几亿人聊出不同的故事。" },
      { type: "p", text: "业内观察人士分析，这种表情包的爆火一方面源于画面本身的高辨识度，另一方面也精准切中了当下年轻人的集体情绪。如果你还没跟上这个梗，今天的瓜课可得抓紧补上了。" },
    ],
  },
  {
    id: "mingxing-hongtan",
    category: "mingxing",
    title: "红毯造型大赏：谁是今晚最会穿的女星？网友投票进行中",
    summary: "一场品牌盛典红毯刚刚落幕，多位女星的造型成为讨论焦点，网友发起的『红毯最佳穿搭』投票正在火热进行。",
    cover: "https://readdy.ai/api/search-image?query=%E7%BA%A2%E6%AF%AF%E7%8E%B0%E5%9C%BA%E5%A5%B3%E6%98%8E%E6%98%9F%E5%8D%8E%E4%B8%BD%E7%A4%BC%E6%9C%8D%E9%80%A0%E5%9E%8B%E8%B5%B0%E8%BF%87%E6%91%84%E5%BD%B1%E5%8C%BA%2C%E9%97%AA%E5%85%89%E7%81%AF%E5%92%8C%E7%BA%A2%E6%AF%AF%E9%95%BF%E5%BB%8A%2C%E9%AB%98%E9%9B%85%E6%97%B6%E5%B0%9A%E5%A5%B3%E6%98%8E%E6%98%9F%E9%80%A0%E5%9E%8B&width=1280&height=720&seq=gk-news-a6&orientation=landscape",
    date: "2026-09-03",
    time: "22:45",
    views: "15.4w",
    hot: true,
    featured: false,
    author: "瓜田守望者",
    tags: ["红毯造型", "盛典现场", "穿搭投票"],
    blocks: [
      { type: "p", text: "昨晚某时尚品牌年度盛典红毯环节星光熠熠，数十位明星盛装出席。从复古宫廷风到极简高级感，女星们的造型各有千秋，现场尖叫声此起彼伏。" },
      { type: "p", text: "红毯结束后，网友自发发起的『最佳穿搭』投票迅速升温。有人偏爱影后秦念那一身利落剪裁，也有人对新生代演员苏晴的清新色系造型赞不绝口，讨论呈现出『神仙打架』的局面。" },
      { type: "quote", text: "红毯的看点从来不只在衣服本身，更在于每个人如何穿出自己的态度。" },
      { type: "p", text: "目前投票仍在进行，竞争相当胶着。除了服装，当晚多位明星的互动细节同样被镜头捕捉，想看完整名场面的瓜友，可以持续关注我们的造型盘点。" },
    ],
  },
  {
    id: "zongyi-xinshou",
    category: "zongyi",
    title: "新综官宣导师阵容：『顶流+老将』混搭，会碰撞出什么火花？",
    summary: "一档全新音综正式官宣导师班底，顶流歌手与资深音乐人的新鲜组合引发猜测，节目定位成最大悬念。",
    cover: "https://readdy.ai/api/search-image?query=%E9%9F%B3%E4%B9%90%E7%BB%BC%E8%89%BA%E5%AF%BC%E5%B8%88%E5%BA%A7%E4%BD%8D%E7%AE%80%E7%BA%A6%E8%88%9E%E5%8F%B0%E6%91%86%E6%94%BE%E4%BA%86%E5%87%A0%E6%8A%8A%E9%AB%98%E8%83%8C%E6%A4%85%E5%92%8C%E9%BA%A6%E5%85%8B%E9%A3%8E%2C%E8%88%9E%E5%8F%B0%E7%81%AF%E5%85%89%E6%B0%9B%E5%9B%B4%E7%A7%91%E6%8A%80%E6%84%9F&width=1280&height=720&seq=gk-news-a7&orientation=landscape",
    date: "2026-09-03",
    time: "18:00",
    views: "6.8w",
    hot: false,
    featured: false,
    author: "现场观众",
    tags: ["音综官宣", "导师阵容", "综艺"],
    blocks: [
      { type: "p", text: "今天，一档筹备已久的全新音乐类综艺正式揭晓导师阵容。令人意外的是，节目组没有沿用传统全老将配置，而是大胆启用『人气歌手+资深音乐人』的混搭组合。" },
      { type: "p", text: "新生代顶流与圈内口碑极佳的老将同台，会擦出怎样的火花成为观众最大的好奇点。有网友直言：这种配置要么是惊喜，要么是惊吓，但无论如何都值得期待。" },
      { type: "quote", text: "新节目敢在阵容上玩出新意，至少说明它想给观众带来点不一样的东西。" },
      { type: "p", text: "据节目组透露，赛制上也将做出创新，更多细节会在近期陆续放出。想第一时间掌握节目动态的瓜友，记得把我们的栏目页加入收藏。" },
    ],
  },
  {
    id: "yingshi-houhua",
    category: "yingshi",
    title: "热播剧收官幕后花絮流出：原来这个名场面是这样拍的",
    summary: "一部大热剧集收官后放出制作特辑，揭秘多个催泪名场面背后的拍摄故事，让观众直呼『破防』。",
    cover: "https://readdy.ai/api/search-image?query=%E6%8B%8D%E6%91%84%E7%8E%B0%E5%9C%BA%E6%91%84%E5%BD%B1%E6%9C%BA%E5%B7%A5%E4%BD%9C%E4%BA%BA%E5%91%98%E6%89%93%E5%85%89%E6%9D%BF%E5%92%8C%E5%AF%BC%E6%BC%94%E7%9B%91%E8%A7%86%E5%B1%8F%E5%B9%95%2C%E5%B9%95%E5%90%8E%E8%8A%B1%E7%B5%AE%E7%8E%B0%E5%9C%BA%E6%B0%9B%E5%9B%B4&width=1280&height=720&seq=gk-news-a8&orientation=landscape",
    date: "2026-09-02",
    time: "14:30",
    views: "11.2w",
    hot: false,
    featured: false,
    author: "追剧前线",
    tags: ["幕后花絮", "收官特辑", "拍摄故事"],
    blocks: [
      { type: "p", text: "大热剧《逆光而行》收官后，官方趁热放出一支制作特辑，揭秘了剧中多段高光戏份的拍摄幕后，迅速登上热搜。" },
      { type: "p", text: "特辑中，导演坦言剧中那段被观众反复讨论的雨夜对话戏，其实是在连续低温环境下一次次重拍完成的。为了呈现最真实的情绪，演员反复调整状态，连工作人员都忍不住红了眼眶。" },
      { type: "quote", text: "那些让你『破防』的镜头，背后往往是整个剧组咬紧牙关的坚持。" },
      { type: "p", text: "花絮曝光后，不少观众表示『看完更懂这部剧了』。从剧集到幕后，这份诚意或许正是它收获口碑的关键。" },
    ],
  },
  {
    id: "yinyue-xindan",
    category: "yinyue",
    title: "本周新歌热度榜：这五首单曲凭什么霸榜？乐评人逐一点评",
    summary: "最新一期新歌热度榜出炉，五首单曲凭借独特风格入围前列，乐评人从旋律与歌词角度给出专业解读。",
    cover: "https://readdy.ai/api/search-image?query=%E9%9F%B3%E4%B9%90%E6%92%AD%E6%94%BE%E5%99%A8%E8%80%B3%E6%9C%BA%E5%92%8C%E4%B9%90%E8%B0%B1%E7%AC%94%E8%AE%B0%E6%9C%AC%E6%91%86%E5%9C%A8%E6%A1%8C%E4%B8%8A%2C%E7%81%AF%E5%85%89%E6%98%8E%E4%BA%AE%E7%9A%84%E9%9F%B3%E4%B9%90%E7%A0%94%E7%A9%B6%E7%8E%B0%E5%9C%BA%2C%E7%94%B5%E5%AD%90%E9%9F%B3%E4%B9%90%E5%88%B6%E4%BD%9C&width=1280&height=720&seq=gk-news-a9&orientation=landscape",
    date: "2026-09-02",
    time: "10:05",
    views: "4.9w",
    hot: false,
    featured: false,
    author: "热榜观察员",
    tags: ["新歌榜", "乐评", "单曲推荐"],
    blocks: [
      { type: "p", text: "本周新歌热度榜新鲜出炉，五首风格迥异的单曲凭借高质量制作强势上榜。从电子流行到温柔民谣，榜单呈现出多元并存的态势。" },
      { type: "p", text: "其中一首由新生代创作人操刀的单曲尤为亮眼，歌词以细腻的笔触描绘当代年轻人的漂泊心境，被不少听众单曲循环。乐评人评价其『旋律抓耳，词有温度』。" },
      { type: "quote", text: "能打动人心的歌，往往不用华丽的辞藻，真实就已经足够动人。" },
      { type: "p", text: "榜单数据同样反映趋势：听众对『有内容』的音乐偏好愈发明显。想拓宽歌单的瓜友，这份榜单值得细细品一品。" },
    ],
  },
  {
    id: "shejiao-tuwei",
    category: "shejiao",
    title: "今天的热搜关键词：从『小镇做题家』到『松弛感』，词条背后是什么",
    summary: "透过今日多条热搜关键词，一起看看年轻人热搜背后的集体情绪与社会话题变迁。",
    cover: "https://readdy.ai/api/search-image?query=%E6%89%8B%E6%9C%BA%E6%90%9C%E7%B4%A2%E6%A1%86%E8%AF%8D%E6%9D%A1%E5%92%8C%E7%81%AB%E7%83%AD%E8%AF%8D%E5%9B%BE%E8%A7%A3%2C%E6%8A%BD%E8%B1%A1%E7%A4%BE%E4%BC%9A%E8%AF%9D%E9%A2%98%E5%92%8C%E6%96%B0%E9%97%BB%E5%85%83%E7%B4%A0%E7%9A%84%E5%B9%B3%E9%9D%A2%E6%8F%92%E7%94%BB&width=1280&height=720&seq=gk-news-a10&orientation=landscape",
    date: "2026-09-01",
    time: "20:30",
    views: "13.6w",
    hot: true,
    featured: false,
    author: "热榜观察员",
    tags: ["热搜关键词", "社会话题", "年轻人"],
    blocks: [
      { type: "p", text: "如果你今天打开热搜，会发现讨论最集中的话题已经从猎奇八卦，悄然转向对生活方式的探讨。『小镇做题家』『松弛感』等关键词轮番占据前列。" },
      { type: "p", text: "这背后的变化值得玩味。当物质讨论逐渐退潮，年轻人开始把注意力投向如何与自己和解、如何定义生活的意义，折射出更深的时代情绪。" },
      { type: "quote", text: "热搜是一座窗口，透过词条的起伏，我们能看见一代人真实的思考。" },
      { type: "p", text: "从追星吃瓜到社会议题，热搜的多元恰恰说明我们关注的世界越来越丰富。今天的你，又被哪个词条击中过呢？" },
    ],
  },
];